import { generateSignatureHtml } from "../EmailSignature";
import "./index.css";

export default function TemplatePreviewModal({
  open,
  onOpenChange,
  template,
}) {

  if (!open) return null;
  
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      zIndex: 1050,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        maxWidth: '800px',
        maxHeight: '90vh',
        overflow: 'auto',
        margin: '20px'
      }}>
        {/* Header */}
        <div className="p-3 border-bottom d-flex justify-content-between align-items-center">
          <h5 className="mb-0">Email Preview</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => onOpenChange(false)}
          ></button>
        </div>

        {/* Body */}
        <div className="p-3">
          <div className="mb-3">
            <strong>Subject:</strong> {template.subject || "No subject"}
          </div>
          <div className="border p-3">
            <div
              dangerouslySetInnerHTML={{
                __html:
                  (template.body ||
                      "<p class='text-muted fst-italic'>No content</p>") +
                  (template.signature
                    ? (typeof template.signature === 'string' ? template.signature : generateSignatureHtml({ ...template.signature, logoUrl: template.company_logo }))
                    : ""),
              }}
            />
          </div>
         
        </div>
      </div>
    </div>
  );
}
